import React from 'react';
import { useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import RouteParameter from '../../components/RouteParameter';
import Layout from '../../features/Layout';

const AppointmentHistoryList = React.lazy(() =>
  import('../../views/AppointmentHistoryList')
);

const params = [];
const AppointmentHistoryListRoute = () => {
  const location = useLocation();

  return (
    <RouteParameter location={location} params={params} fallback={null}>
      <Layout>
        <AppointmentHistoryList />
      </Layout>
    </RouteParameter>
  );
};

AppointmentHistoryListRoute.propTypes = {};

AppointmentHistoryListRoute.defaultProps = {};

const mapStateToProps = () => ({});

export default connect(mapStateToProps)(AppointmentHistoryListRoute);
